<template>
	<div class="downloadzone">
		<headerview :cur="6"></headerview>
		
		<div class="content">

			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'下载专区'" :name="'下载专区'" :imgtype="'5'" width="2.23"></tipcon>
				</div>	
				
				<div class="min-h"> 
					<div class="black_c">
						<div class="l_c">
							<zonelist :sign='4'></zonelist>
						</div>
						<div class="r_c">
							<zonelist :sign='5'></zonelist>
						</div>
					</div>
					
					
					<div class="black_c">
						<div class="l_c">
							<zonelist :sign='6'></zonelist>
						</div>
						<div class="r_c">
							<zonelist :sign='7'></zonelist>
						</div>
					</div>
				</div>
				
			</div>	
			
		</div>
				
		<footview></footview>
		
	</div>
	
</template>

<script>
	
import tipcon from "../../../com/tipcon.vue";
import zonelist from "../../../com/zonelist.vue";

export default {
  components: {
	 tipcon,
	 zonelist
  },
  
  data: function() {
    return {
         
		 
    };
  },
  
  mounted() {
		
  },

  methods: {
		
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.downloadzone{
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.min-h{
				padding-bottom: 40px;
			}
			.black_c{
				margin-top: 40px;
				display: flex;
				.l_c{
					flex: 1;
					margin-right: 40px;
				}
				.r_c{
					flex: 1;
					margin-left: 40px;
				}
			}
			
		}
		
		
	}
			
			
	
}
	
</style>
